'use strict';

const PRIO_L = { critical:'🔴 Crítica', high:'🔵 Alta', medium:'🟡 Media', low:'🟢 Baja' };

const EVENTS = {
  ticket_new: {
    title: (d) => `🎫 Nuevo ticket — ${PRIO_L[d.ticket?.priority] || ''}`,
    body:  (d) => d.ticket?.title || 'Nuevo ticket recibido',
    tag:   (d) => `ticket-new-${d.ticket?.id}`,
  },
  ticket_escalated: {
    title: (d) => `⬆️ Ticket escalado a N${d.ticket?.level}`,
    body:  (d) => `${d.ticket?.title || d.ticket?.ref} — ${d.reason || ''}`,
    tag:   (d) => `ticket-escalated-${d.ticket?.id}`,
  },
  ticket_updated: null, // no push para actualizaciones genéricas
};

export function requestPushPermission() {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'default') {
    Notification.requestPermission();
  }
}

export function sendPushNotification(event) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;

  const cfg = EVENTS[event.type];
  if (!cfg) return;

  const title   = cfg.title(event);
  const body    = cfg.body(event);
  const tag     = cfg.tag(event);
  const iconUrl = 'https://www.uneatlantico.es/themes/uneatlantico/favicon.ico';

  const n = new Notification(title, {
    body,
    tag,            // evita duplicados del mismo ticket
    icon:    iconUrl,
    badge:   iconUrl,
    renotify: false,
    silent:  false,
  });

  // Clic en la notificación → abrir el ticket
  n.onclick = () => {
    window.focus();
    if (event.ticket?.id) {
      window.location.href = `/backdesk/tickets/${event.ticket.id}`;
    }
    n.close();
  };

  // Cerrar automáticamente a los 8 segundos
  setTimeout(() => n.close(), 8000);
}
